// Data-only sidenav dest lists. layoutLinks.tsx keeps the permissioned React hooks.
// Both arrays live here so supportContext can import project sidebar titles without
// pulling useAuthContext or the router. rawAdminMainLinks moved with rawUserMainLinks
// so the two sidenav dest lists stay one source of truth; the assistant does not use admin screens.

export interface LayoutLinkInterface {
  path: string;
  shortcutPath?: string;
  title: string;
  selected?: boolean;
  external?: boolean;
  testId?: string;
}

export const rawAdminMainLinks: LayoutLinkInterface[] = [
  {
    path: '/admin/tenants',
    title: 'Tenants',
    testId: 'sidebar-tenants',
  },
  {
    path: '/admin/projects',
    title: 'Projects',
    testId: 'sidebar-projects',
  },
  {
    path: '/admin/stepTemplates',
    title: 'Templates',
    testId: 'sidebar-templates',
  },
  {
    path: '/admin/media-categories',
    title: 'Media Categories',
    testId: 'sidebar-media-categories',
  },
  {
    path: '/admin/stores',
    title: 'Stores',
    testId: 'sidebar-stores',
  },
  {
    path: '/admin/brands',
    title: 'Brands',
    testId: 'sidebar-brands',
  },
  {
    path: '/admin/users',
    title: 'Users',
    testId: 'sidebar-users',
  },
  {
    path: '/admin/groups',
    title: 'Permissions',
    testId: 'sidebar-permissions',
  },
  {
    path: '/admin/pillars',
    title: 'Pillars',
    testId: 'sidebar-pillars',
  },
  {
    path: '/admin/tag-groups',
    title: 'Tags',
    testId: 'sidebar-tags',
  },
  {
    path: '/admin/bulletins',
    title: 'Bulletins',
    testId: 'sidebar-bulletins',
  },
  {
    path: '/admin/feature-flags',
    title: 'Feature Flags',
    testId: 'sidebar-feature-flags',
  },
  {
    path: '/admin/restore-analytics',
    title: 'ReStore Analytics',
    testId: 'sidebar-restore-analytics',
  },
];

export const rawUserMainLinks: LayoutLinkInterface[] = [
  {
    path: '/dashboard',
    shortcutPath: '/projects/dashboard',
    title: 'Dashboard',
    testId: 'sidebar-dashboard',
  },
  {
    path: '/reports',
    shortcutPath: '/projects/reports',
    title: 'Reports',
    testId: 'sidebar-reports',
  },
  {
    path: '/activities',
    shortcutPath: '/projects/activities',
    title: 'Tasks',
    testId: 'sidebar-tasks',
  },
  {
    path: '/gallery',
    shortcutPath: '/projects/gallery',
    title: 'Gallery',
    testId: 'sidebar-gallery',
  },
  {
    path: '/broadcasts',
    shortcutPath: '/projects/broadcasts',
    title: 'Broadcasts',
    testId: 'sidebar-broadcasts',
  },
];
